import { render, staticRenderFns } from "./jobPost.vue?vue&type=template&id=2206bc4e&scoped=true&"
import script from "./jobPost.vue?vue&type=script&lang=js&"
export * from "./jobPost.vue?vue&type=script&lang=js&"
import style0 from "./jobPost.vue?vue&type=style&index=0&id=2206bc4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206bc4e",
  null
  
)

export default component.exports